<template>
  <div class="emb-aside-banner-v1" v-if="sidebanner1">
    <router-link
      :to="{name: 'Products', query: {category: sidebanner1.Category_ID, subcategory: sidebanner1.Sub_Category_ID}}"
    >
      <img
        class="emb-card"
        alt="aside-banner"
        :src="sidebanner1.Image_547_x_315px"
        width="547"
        height="315"
      />
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["sidebanner1"],
};
</script>
